module.exports = "/images/vendor/flag-icon-css/flags/1x1/ke.svg?87900162ad67f9a694841b1d7abe72c8";